module.exports = __webpack_public_path__ + "img/Iknow-min.f4a011de.png";